export const createCopilotChartLoader = (load) => {
    let chartPromise;

    return () => {
        if (!chartPromise) {
            chartPromise = load().catch((error) => {
                chartPromise = undefined;
                throw error;
            });
        }

        return chartPromise;
    };
};

export const loadCopilotChart = createCopilotChartLoader(
    () => import('shards/ForceBI/components/Charts/Chart'),
);
